import i from"styled-components";const t=i.div`
	width: ${i=>i.width?`${i.width}px`:"400px"};
	position: relative;
	border-radius: 4px;
	padding: 32px 24px 24px 24px;
	display: flex;
	flex-direction: column;
	align-items: center;
`,e=i.div`
	width: ${i=>i.iconWidth?i.iconWidth:64}px;
	height: ${i=>i.iconHeight?i.iconHeight:64}px;
	display: flex;
	justify-content: center;
	align-items: end;
`,d=i.div`
	margin-top: ${i=>"SMALL"===i.size?8:16}px;
	text-align: center;
	max-width: 100%;
`,n=i.div`
	display: flex;
	margin-top: ${i=>"SMALL"===i.size?8:24}px;
	gap: 12px;
	width: 100%;
`,p=i.div`
	margin-top: 4px;
	max-width: 100%;
	text-align: center;
	max-width: 100%;
`;export{n as ButtonContainer,t as StateComponentContainer,d as StateHeading,e as StateIcon,p as StateSubline};
